// @flow
import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { translate } from 'react-i18next';
import { withTheme } from 'styled-components';

type Props = {
  onClick: () => void;
  t: any;
  theme: any;
}

function PrintButton({ t, theme, onClick }: Props) {
  return (
    <RaisedButton
      label={t('print').toUpperCase()}
      onClick={onClick}
      backgroundColor={theme.colors.accent}
      labelStyle={{ color: theme.colors.tertiaryText }}
    />
  );
}

export default withTheme(translate()(PrintButton));



// WEBPACK FOOTER //
// ./src/advertisers/components/PrintButton.js